import { Typography } from '../../../widgets/Typography';

const steps = [
  'Our client success team will receive your request and get started on it right away.',
  'They will carefully review and process everything within 5 business days.',
  "You'll be notified with a confirmation once your request has been fully processed.",
];

export default function OnboardingConfirmation() {
  return (
    <div className="flex w-2xl flex-col items-start gap-4 rounded-lg border border-taupe-400 bg-white p-6 shadow-md">
      <div className="flex flex-col items-start gap-1">
        <Typography variant="body-lg" weight="semibold">
          Your Member List Is Ready to Sync!
        </Typography>
        <Typography variant="body-sm" className="text-grey-600 text-pretty">
          All data is ready. Click “Confirm” below to begin syncing. You’ll be
          notified once the process is complete.
        </Typography>
        <div className="border-taupe-550 mt-6 flex w-full flex-row items-center justify-between rounded-xl border bg-taupe-100 p-4">
          <div className="flex flex-col gap-4">
            <Typography
              variant="body-sm"
              className="text-neutral-800"
              weight="semibold"
            >
              Here's what happens next:
            </Typography>
            <div className="flex flex-col gap-6">
              {steps.map((step, index) => (
                <div
                  key={step}
                  className="group flex flex-row items-center gap-2"
                >
                  <div className="relative flex h-6 w-6 items-center justify-center rounded-full bg-taupe-900 text-white">
                    <div className="absolute bottom-0 block h-6 w-px translate-y-full bg-taupe-900/50 group-last:hidden" />
                    <Typography
                      variant="body-xs"
                      className="text-center text-white"
                    >
                      {index + 1}
                    </Typography>
                  </div>
                  <Typography variant="body-sm" className="text-neutral-700">
                    {step}
                  </Typography>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
